import { render, staticRenderFns } from "./CollapseTextWithTooltip.vue?vue&type=template&id=d192f88a&scoped=true"
import script from "./CollapseTextWithTooltip.vue?vue&type=script&lang=js"
export * from "./CollapseTextWithTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d192f88a",
  null
  
)

export default component.exports